import { useEffect, useState } from 'react';

export const useAdblockDetected = () => {
    const [isAdblockDetected, setIsAdblockDetected] = useState(false);

    useEffect(() => {
        const fakeAdblockElement = document.createElement('div');
        fakeAdblockElement.className = 'textads banner-ads banner_ads ad-unit ad-zone ad-space adsbox';

        fakeAdblockElement.style.height = '1px';

        document.body.appendChild(fakeAdblockElement);

        const { offsetHeight } = fakeAdblockElement;
        if (offsetHeight) {
            setIsAdblockDetected(false);
            sessionStorage.setItem('adblockDetected', String(false));
        } else {
            setIsAdblockDetected(true);
        }
    }, []);

    return {
        isAdblockDetected,
    };
};
